import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { combineLatest, filter, map, take } from "rxjs";

export const softAuthGuard: CanMatchFn = (route, segments) => {
    const auth = inject(AuthService);
    return combineLatest([auth.isLoading$, auth.isAuthenticated$]).pipe(
        filter(([loading]) => !loading),
        take(1),
        map(([_, isAuthenticated]) => isAuthenticated)
    );
};
